import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { userFromJSON, IUserData, UserRecord } from "common/records/User";
import { checkDate } from "common/helpers/Date";

export const jobAssignmentFromJSON = (json: Partial<IJobAssignmentData>): JobAssignmentRecord => {
  const data: IJobAssignmentRecord = { ...(json as any as IJobAssignmentRecord) };

  if (json.user) {
    if (json.user.org) {
      delete json.user.org;
    }
    data.user_id = json.user.id;
    data.user = userFromJSON(json.user);
  }

  if (json.created_at) {
    data.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    data.updated_at = checkDate(json.updated_at);
  }

  return new JobAssignmentRecord(data);
};

export const toJSON = (jobAssignment: JobAssignmentRecord): IJobAssignmentData => {
  const json = jobAssignment.toJSON() as Partial<IJobAssignmentData>;

  if (json.id !== undefined && json.id <= 0) {
    delete json.id;
  }

  return json as IJobAssignmentData;
};

type AssignmentStatusType = "active" | "archived";

export interface IJobAssignmentData {
  id: number;
  status: AssignmentStatusType;
  status_changed: Date;
  user: IUserData;
  user_id?: number;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IJobAssignmentRecord {
  id: Nullable<number>;
  status: Nullable<AssignmentStatusType>;
  status_changed: Nullable<Date>;
  user: Nullable<UserRecord>;
  user_id: Nullable<number>;
  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;
}

export const defaultJobAssignmentProps = {
  id: 0,
  status: "active" as AssignmentStatusType,
  status_changed: null,
  user: null,
  user_id: null,
  created_at: null,
  updated_at: null,
};

export class JobAssignmentRecord
  extends Record<IJobAssignmentRecord>(defaultJobAssignmentProps)
  implements IJobAssignmentRecord {}

export const emptyJobAssignmentValue = jobAssignmentFromJSON({} as IJobAssignmentData);
